import React, { useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import {
  Button,
  Chip,
  IconButton,
  TablePagination,
  Typography,
  Checkbox,
  Box,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { statusList } from "../../data";
import { AuthContext } from "../../context/AuthContext";

import Grid from "@mui/material/Grid2";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

const cash = "/cash.png";
const ucb = "/ucb.png";

const city = "/city.png";

const brac = "/brac.png";

const ssl = "/ssl.png";

const bkash = "/bkash.png";

const due = "/due.png";
const discount = "/discount.png";
const refund = "/refund.png";
let paymentMethodList = [
  { name: "Cash", color: "#FEF7C3", icon: cash },
  { name: "UCB", color: "#FEE4E2", icon: ucb },
  { name: "City", color: "#DCFAE6", icon: city },
  { name: "Brac", color: "#FFE6D5", icon: brac },
  { name: "SSL", color: "#E0E8FF", icon: ssl },
  { name: "Bkash", color: "#EBE9FE", icon: bkash },
];
const TechnicianRepairList = ({
  loading,
  pageLoading,
  tableDataList,
  clearFilter,
  handleDeleteDialog,
  message,
}) => {
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);

  // console.log(
  //   "statusList",
  //   statusList?.find((el) => el.name === "Rework")?.color
  // );
  const calculateRowTotalAmount = (row) => {
    const issueTotal = row?.issues?.length
      ? row.issues.reduce((sum, issue) => sum + (issue.repair_cost || 0), 0)
      : 0;
    const productTotal = row?.product_details?.length
      ? row.product_details.reduce(
          (sum, product) => sum + (product.price || 0),
          0,
        )
      : 0;

    // return issueTotal + productTotal;
    return issueTotal;
  };

  const calculateRepairIssueTotals = (repairList) => {
    if (!repairList?.length) {
      return { totalRepairCost: 0, totalIssues: 0 };
    }

    return repairList.reduce(
      (totals, repair) => {
        const issues = repair?.issues ?? [];
        const repairCost = issues.reduce(
          (sum, issue) => sum + (issue.repair_cost || 0),
          0,
        );

        return {
          totalRepairCost: totals.totalRepairCost + repairCost,
          totalIssues: totals.totalIssues + issues.length,
        };
      },
      { totalRepairCost: 0, totalIssues: 0 },
    );
  };

  const calculateTotalAmount = (transactionInfo) => {
    return transactionInfo?.length
      ? transactionInfo.reduce((acc, item) => acc + (item.amount || 0), 0)
      : 0;
  };

  const formatPaymentMethods = (transactionInfo) => {
    if (!transactionInfo?.length) {
      return <Typography variant="body2">N/A</Typography>;
    }
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {transactionInfo.map((item, index) => (
          <Box>
            {item.name} :{" "}
            <Chip
              key={index}
              label={`${item.amount?.toLocaleString() || 0}`}
              size="small"
              variant="outlined"
              sx={{
                backgroundColor: "#F5F5F5",
                color: "#333",
                border: "1px solid #E0E0E0",
                fontSize: "11px",
                height: "24px",
              }}
            />
          </Box>
        ))}
      </Box>
    );
  };

  const formatServiceDetails = (issues, productDetails) => {
    const issueNames = issues?.length
      ? issues.map((item) => item.name).filter(Boolean)
      : [];
    const productNames = productDetails?.length
      ? productDetails.map((item) => item.name).filter(Boolean)
      : [];

    const allNames = [...issueNames, ...productNames];
    return allNames.length > 0 ? allNames.join(", ") : "N/A";
  };

  // Calculate total debit and credit amounts
  const calculateTotals = () => {
    let totalDebit = 0;
    let totalCredit = 0;

    tableDataList.forEach((transaction) => {
      const amount = calculateTotalAmount(transaction.transaction_info);
      if (transaction.transaction_type === "debit") {
        totalDebit += amount;
      } else if (transaction.transaction_type === "credit") {
        totalCredit += amount;
      }
    });

    return { totalDebit, totalCredit };
  };
  const calculatePaymentMethodTotals = () => {
    return paymentMethodList.map((item) => {
      const amount = tableDataList.reduce((acc, transaction) => {
        const paymentAmount =
          transaction?.transaction_info?.find((info) => info.name === item.name)
            ?.amount || 0;

        if (transaction.transaction_type === "debit") {
          return acc - paymentAmount;
        } else {
          return acc + paymentAmount;
        }
      }, 0);
      // return {
      //   name: item.name,
      //   amount: amount,

      // };
      return (
        <Box
          key={item.name}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          {item.name}:{" "}
          <Chip
            // label={`${item.amount?.toLocaleString() || 0}`}
            label={amount.toLocaleString()}
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: "#F5F5F5",
              color: "#333",
              border: "1px solid #E0E0E0",
              // fontSize: "11px",
              height: "24px",
              fontWeight: "bold",
            }}
          />
        </Box>
      );
    });
  };

  const { totalDebit, totalCredit } = calculateTotals();
  const { totalRepairCost, totalIssues } =
    calculateRepairIssueTotals(tableDataList);

  return (
    <div>
      {/* Summary Section */}
      <div
        style={{
          gap: "20px",
          marginBottom: "20px",
          padding: "16px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px solid #e9ecef",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          <div
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "6px",
              border: "1px solid #dee2e6",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#2E7D32",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              Total Service Amount
            </Typography>
            <Typography
              variant="h4"
              sx={{
                color: "#2E7D32",
                fontWeight: "bold",
              }}
            >
              {totalRepairCost.toLocaleString()}
            </Typography>
          </div>

          <div
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "6px",
              border: "1px solid #dee2e6",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#1976D2",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              Total Services
            </Typography>
            <Typography
              variant="h4"
              sx={{
                color: "#1976D2",
                fontWeight: "bold",
              }}
            >
              {totalIssues.toLocaleString()}
            </Typography>
          </div>

          <div
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "6px",
              border: "1px solid #dee2e6",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#6A1B9A",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              Total Repairs
            </Typography>
            <Typography
              variant="h4"
              sx={{
                color: "#6A1B9A",
                fontWeight: "bold",
              }}
            >
              {tableDataList.length.toLocaleString()}
            </Typography>
          </div>
        </div>
      </div>
      <div
        style={{
          overflowX: "auto",

          minWidth: "100%",
          width: "Calc(100vw - 385px)",
          // padding: "10px 16px 0px",
          boxSizing: "border-box",
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ whiteSpace: "nowrap" }}>Date</TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>Repair No</TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>Branch</TableCell>

              <TableCell style={{ whiteSpace: "nowrap" }}>
                Repair Service Details
              </TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>
                Repair Product Details
              </TableCell>

              <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                Total Service Amount
              </TableCell>
              {/* <TableCell style={{ whiteSpace: "nowrap" }}>Status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading &&
              tableDataList.length > 0 &&
              tableDataList.map((row, i) => (
                <>
                  <TableRow
                    key={row?._id}
                    // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {moment(row?.updated_at).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>{row?.repair_id}</TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {row?.branch_id?.name || "N/A"}
                    </TableCell>
                    <TableCell
                      sx={{ maxWidth: "200px", wordWrap: "break-word" }}
                    >
                      {row?.issues &&
                      Array.isArray(row.issues) &&
                      row.issues.length > 0 ? (
                        row.issues.map((issue, idx) => (
                          <div key={issue._id || idx}>
                            {issue.name} -{" "}
                            {issue.repair_cost?.toLocaleString() ?? 0}
                          </div>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </TableCell>

                    <TableCell
                      sx={{ maxWidth: "200px", wordWrap: "break-word" }}
                    >
                      {row?.product_details &&
                      Array.isArray(row.product_details) &&
                      row.product_details.length > 0 ? (
                        row.product_details.map((product, idx) => (
                          <div key={product._id || idx}>
                            {product.name} -{" "}
                            {product.price?.toLocaleString() ?? 0}
                          </div>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </TableCell>
                    <TableCell align="right" sx={{}}>
                      {calculateRowTotalAmount(row).toLocaleString()}
                    </TableCell>

                    {/* <TableCell>
                      <Chip
                        label={row?.status ? "Active" : "Inactive"}
                        variant="outlined"
                        sx={{
                          backgroundColor: row?.status ? "#E8F5E8" : "#FFEBEE",
                          color: row?.status ? "#2E7D32" : "#D32F2F",
                          border: "none",
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                </>
              ))}

            {!loading && tableDataList.length < 1 ? (
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell colSpan={7} style={{ textAlign: "center" }}>
                  <strong> {message}</strong>
                </TableCell>
              </TableRow>
            ) : null}
            {loading && pageLoading()}
          </TableBody>
        </Table>
      </div>
      {/* {tableDataList.length > 0 ? (
        <div>
          <TablePagination
            style={{ display: "block", border: "none" }}
            rowsPerPageOptions={[]}
            count={totalData}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      ) : (
        <br />
      )} */}
    </div>
  );
};

export default TechnicianRepairList;
